import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { inject, onMounted, reactive, ref, watch } from "vue";
import { Formatter } from "@/util/Formatter";
import { validationRules } from "@/ValidationRules";
import { OrderChargeType } from "@/model/enum/OrderChargeType";
import { TaxRateServiceSymbol } from "@/InjectionSymbols";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CancelOrderDialog',
    props: {
        orderTotal: { type: Number, required: true }
    },
    emits: ['confirm'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const taxRateService = inject(TaxRateServiceSymbol);
        const taxrates = reactive([]);
        const selectedTaxRate = ref(null);
        const dialog = ref(false);
        const form = ref(null);
        const formValid = ref(true);
        const cancellationType = ref('free');
        const percentageValue = ref(null);
        const orderCharge = ref({ grossAmount: 0, description: '', type: OrderChargeType.FEE, taxRate: 0.00 });
        onMounted(() => {
            taxRateService.loadAllTaxRates().then(response => {
                taxrates.length = 0;
                taxrates.push(...response);
                if (taxrates.length > 0) {
                    selectedTaxRate.value = taxrates[0];
                }
            });
        });
        // Watch for dialog open to reset values
        watch(() => dialog.value, (isOpen) => {
            if (isOpen) {
                cancellationType.value = 'free';
                percentageValue.value = null;
                orderCharge.value = { grossAmount: 0, description: '', type: OrderChargeType.FEE, taxRate: 0.00 };
                formValid.value = true;
                // Reset form validation
                if (form.value) {
                    form.value.resetValidation();
                }
            }
        });
        function calculateCancellationFee() {
            if (cancellationType.value === 'percentage' && percentageValue.value !== null) {
                orderCharge.value.grossAmount = (props.orderTotal * percentageValue.value) / 100;
            }
        }
        function cancelDialog() {
            dialog.value = false;
        }
        function confirmCancellation() {
            form.value.validate().then((result) => {
                if (result.valid) {
                    orderCharge.value.taxRate = selectedTaxRate.value ? selectedTaxRate.value.rate : 0.00;
                    emit('confirm', orderCharge.value.grossAmount > 0 ? orderCharge.value : null);
                    dialog.value = false;
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                modelValue: dialog.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((dialog).value = $event)),
                "max-width": "600px",
                persistent: ""
            }, {
                activator: _withCtx(({ props }) => [
                    _renderSlot(_ctx.$slots, "activator", { props: props })
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "text-h5 pa-4" }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createTextVNode(" Buchung stornieren ")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "pa-4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_form, {
                                        ref_key: "form",
                                        ref: form,
                                        modelValue: formValid.value,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((formValid).value = $event))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_alert, {
                                                type: "info",
                                                variant: "tonal",
                                                class: "mb-4"
                                            }, {
                                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                    _createTextVNode(" Bitte wählen Sie die Stornierungsbedingungen für diese Buchung. ")
                                                ])),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_container, { class: "pa-0 mb-4" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_row, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                                cols: "6",
                                                                class: "text-start font-weight-bold"
                                                            }, {
                                                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                                    _createTextVNode(" Buchungssumme: ")
                                                                ])),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_v_col, {
                                                                cols: "6",
                                                                class: "text-end"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_unref(Formatter).currency(__props.orderTotal)), 1)
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_divider, { class: "mb-4" }),
                                            _createVNode(_component_v_radio_group, {
                                                modelValue: cancellationType.value,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((cancellationType).value = $event)),
                                                class: "mb-4"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_radio, {
                                                        label: "Kostenfrei stornieren",
                                                        value: "free",
                                                        color: "success"
                                                    }),
                                                    _createVNode(_component_v_radio, {
                                                        label: "Prozentualer Betrag",
                                                        value: "percentage",
                                                        color: "primary"
                                                    }),
                                                    _createVNode(_component_v_radio, {
                                                        label: "Individueller Betrag",
                                                        value: "custom",
                                                        color: "primary"
                                                    })
                                                ]),
                                                _: 1
                                            }, 8, ["modelValue"]),
                                            (cancellationType.value === 'percentage')
                                                ? (_openBlock(), _createBlock(_component_v_container, {
                                                    key: 0,
                                                    class: "pa-0 mb-4"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_text_field, {
                                                            modelValue: percentageValue.value,
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((percentageValue).value = $event)),
                                                            modelModifiers: { number: true },
                                                            label: "Stornierungsgebühr (%)",
                                                            type: "number",
                                                            min: "0",
                                                            max: "100",
                                                            step: "0.01",
                                                            variant: "outlined",
                                                            density: "compact",
                                                            suffix: "%",
                                                            rules: [_unref(validationRules).required, _unref(validationRules).nonNegative],
                                                            onInput: calculateCancellationFee
                                                        }, null, 8, ["modelValue", "rules"])
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (cancellationType.value === 'custom')
                                                ? (_openBlock(), _createBlock(_component_v_container, {
                                                    key: 1,
                                                    class: "pa-0 mb-4"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_text_field, {
                                                            modelValue: orderCharge.value.grossAmount,
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((orderCharge.value.grossAmount) = $event)),
                                                            modelModifiers: { number: true },
                                                            label: "Stornierungsgebühr",
                                                            type: "number",
                                                            min: "0",
                                                            max: __props.orderTotal,
                                                            step: "0.01",
                                                            variant: "outlined",
                                                            density: "compact",
                                                            suffix: "€",
                                                            rules: [_unref(validationRules).required, _unref(validationRules).nonNegative]
                                                        }, null, 8, ["modelValue", "max", "rules"])
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (cancellationType.value !== 'free')
                                                ? (_openBlock(), _createBlock(_component_v_container, {
                                                    key: 2,
                                                    class: "pa-0 mb-4"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_select, {
                                                            modelValue: selectedTaxRate.value,
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedTaxRate).value = $event)),
                                                            rules: [_unref(validationRules).required],
                                                            items: taxrates,
                                                            label: "Mehrwertsteuer",
                                                            "item-props": (item) => ({ title: _unref(Formatter).decimalToPercent(item.rate) }),
                                                            variant: "outlined",
                                                            density: "compact",
                                                            "return-object": ""
                                                        }, null, 8, ["modelValue", "rules", "items", "item-props"])
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (orderCharge.value.grossAmount > 0)
                                                ? (_openBlock(), _createBlock(_component_v_container, {
                                                    key: 3,
                                                    class: "pa-0"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_divider, { class: "mb-3" }),
                                                        _createVNode(_component_v_row, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_col, {
                                                                    cols: "6",
                                                                    class: "text-start font-weight-bold"
                                                                }, {
                                                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                                        _createTextVNode(" Stornierungsgebühr: ")
                                                                    ])),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_v_col, {
                                                                    cols: "6",
                                                                    class: "text-end font-weight-bold text-h6"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_unref(Formatter).currency(orderCharge.value.grossAmount)), 1)
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_spacer),
                                    _createVNode(_component_v_btn, { onClick: cancelDialog }, {
                                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                                            _createTextVNode("Abbrechen")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_btn, {
                                        color: "error",
                                        onClick: confirmCancellation,
                                        disabled: !formValid.value
                                    }, {
                                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                                            _createTextVNode(" Stornieren ")
                                        ])),
                                        _: 1
                                    }, 8, ["disabled"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 3
            }, 8, ["modelValue"]));
        };
    }
});
